@import 'src/global/variables';
@import 'src/global/mixins';
@import '../../global/accessibility.css';

:host {
	display: block;
}

form {
	padding: 1.5rem 1rem;
	background-color: $color-white;

    @include nj-mobile-no-padding;

	p {
		margin-top: 0;
		margin-bottom: 1.5rem;
	}
}

oebbx-station-field,
oebbx-date-field {
	width: 100%;
}

.from-to,
.date-passengers {
	@media #{$screen-min-sm} {
		div > div {
			display: grid;
			grid-template-columns: 1fr 1fr;
			grid-gap: 1rem;
		}
	}

	@media screen and (min-width: ($break-md + 30)) {
		display: grid;
		grid-template-columns: 1fr 1fr;
		grid-gap: 1rem;
	}
}

input[type="checkbox"] {
	@include nj-checkbox;
}

input[type="submit"] {
	@include nj-button;
}

.actions {
	@media screen and (min-width: ($break-md + 30)) {
		display: flex;
		justify-content: flex-end;
		align-items: center;

		.nj-from-to--default &,
		.nj-from-to--outward &,
		.nj-from-to--return & {
			position: relative;
			z-index: 1;

			width: 50%;
			margin-left: auto;
		}

		.nj-from-to--default & {
			margin-top: -2.75rem;
		}

		// .nj-from-to--return & {
		// 	margin-top: -5rem;
		// }
	}

	@media #{$screen-max-sm} {
		display: flex;

		.submitButton {
			flex: 1 0 auto;
            justify-content: center;
		}
	}
}

.nj-from-to--return {
	@media screen and (min-width: ($break-md + 30)) {
		display: grid;
		grid-template-columns: 2fr 1fr 1fr;
		grid-gap: 1rem;

		p {
			margin-bottom: 0;
		}

		.date-passengers {
			display: block;

			div > div {
				display: block;
			}
		}

		.actions {
			width: auto;
			align-items: center;
		}
	}
}

.nj-from-to-error-message {
    color: $color-error;
    margin: 0 0 20px;

    @media #{$screen-min-md} {
        margin: 0 10px 0 0;
    }

}
